export function MaintenanceMode() {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-white p-8">
      <img
        alt="Grocery TV Logo"
        className="h-10 w-auto"
        src="/gtv-logo-blue.svg"
      />
      <h1 className="text-2xl font-bold">We&apos;ll be right back</h1>
      <p className="text-muted-foreground mt-2 text-sm">
        We&apos;re performing scheduled maintenance. Check back soon.
      </p>
    </div>
  );
}
